// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const baseUrl = process.env.REACT_APP_API_URL;
import LocalStorage from 'utilities/localStorage';
import { withSessionTermination } from 'utilities/withSessionTermination';
// Define a service using a base URL and expected endpoints
export const emsApi = createApi({
  reducerPath: 'ems',
  baseQuery: withSessionTermination(
    fetchBaseQuery({
      baseUrl,
      prepareHeaders: (headers) => {
        const user = LocalStorage.getItem('Gravity_user');
        const authToken = user?.token;
        const sessionToken = user?.session_token;
        if (authToken) {
          headers.set('authorization', `Bearer ${authToken}`);
        }
        if (sessionToken) {
          headers.set('x-session-token', sessionToken);
        }
        return headers;
      }
    })
  ),
  tagTypes: ['ems'],

  endpoints: (builder) => ({
    // #region Creating EMS record
    createEms: builder.mutation({
      query: (payload) => ({
        url: 'ems',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['ems']
    }),
    // #endregion

    // #region EMS records
    getEms: builder.query({
      query: (payload) => {
        return {
          url: `ems/${payload}`
          // params: payload
        };
      },
      providesTags: ['ems']
    }),
    // #endregion

    // #region EMS records
    getEmsRoomNumberMasters: builder.query({
      query: (payload) => {
        return {
          url: `ems-room-number-masters`,
          params: payload
        };
      }
    })
    // #endregion
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateEmsMutation,
  useGetEmsQuery,
  useGetEmsRoomNumberMastersQuery
} = emsApi;
